import LineString from 'ol/geom/LineString';
import Polygon from 'ol/geom/Polygon';
import Point from 'ol/geom/Point';
import Feature from 'ol/Feature';
import proj4 from 'proj4';
import DrawFunctions from './DrawFunctions.js'
import colors from 'dxf/src/util/colors'

export default class FeatureDrawer {
    constructor(projection = null, mapprojection) {
        this.transformFromProjection = false
        this.projection = projection;

        if (projection != null) {
            this.source = new proj4.Proj(projection);

            if(mapprojection){
                this.dest = new proj4.Proj(mapprojection);
            }

            if (this.source.tyker_rz && this.source.tyker_s && this.source.tyker_x && this.source.tyker_y && this.source.tyker_px && this.source.tyker_py) {
                this.transformFromProjection = true;
            }
        }
    }


    drawFeature(item, index) {
        if (item.inPaperSpace) {
            return null;
        }
        var feature = null;

        switch (item.type) {
            case "LINE":
                feature = this.drawLine(item);
                break;
            case "POINT":
                feature = this.drawPoint(item);
                break;
            case "ARC":
                feature = this.drawArc(item);
                break;
            case "CIRCLE":
                feature = this.drawCircle(item);
                break;
            case "3DFACE":
                feature = this.draw3DFace(item);
                break;
            case "POLYGON":
                feature = this.drawPolygon(item);
                break;
            case "POLYLINE":
            case "LWPOLYLINE":
                feature = this.drawPolyline(item);
                break;
            case "MTEXT":
                //feature = this.drawMText(item);
                break;
            case "HATCH":
                feature = this.drawHatch(item);
                break;
            case "VIEWPORT": 
                break;
            default:
                throw new Error("Unknown feature: " + item.type)
        }

        if (feature != null) {
            if (index != null)
                feature.set('index', index);
            return feature;
        }
        return null;
    }

    drawLine(item) {
        var start = { x: item.start.x, y: item.start.y };
        var end = { x: item.end.x, y: item.end.y };
        if (this.projection != null) {
            start = this.transformCoordinates(start)
            end = this.transformCoordinates(end)
        }
        var lineString = new LineString([[start.x, start.y], [end.x, end.y]]);
        if (item.transforms) {
            DrawFunctions.transformGeom(lineString, item.transforms);
        }

        var feature = new Feature(lineString);
        feature.set('vertices', [[start.x, start.y], [end.x, end.y]])
        return feature;
    }

    drawPoint(item) {
        var point = { x: item.x, y: item.y };
        if (this.projection != null) {
            point = this.transformCoordinates(point)
        }
        var pointf = new Point([point.x, point.y]);
        if (item.transforms) {
            DrawFunctions.transformGeom(pointf, item.transforms);
        }
        var feature = new Feature(pointf);
        return feature;
    }

    drawArc(item) {
        //TODO Marc: is this right for dxf arc?
        var center = { x: item.x, y: item.y };
        var startAngle = item.startAngle;
        var endAngle = item.endAngle;
        var startPoint = item.startPoint || { x: 0, y: 0 };
        var arc;
        var points;

        if (item.startPoint) {
            points = DrawFunctions.createArcRadius(startAngle, endAngle, center, startPoint);
        } else {
            points = DrawFunctions.createArc(startAngle, endAngle, center, item.r);
        }

        if (this.projection != null) {
            points.forEach((item, index) => {
                ({ x: points[index][0], y: points[index][1] } = this.transformCoordinates({ x: item[0], y: item[1] }));
            });
        }

        arc = new LineString(points)
        if (item.transforms) {
            DrawFunctions.transformGeom(arc, item.transforms);
        }

        var feature = new Feature(arc);
        feature.set('vertices', [points[0], points[points.length - 1]])
        return feature;
    }

    drawCircle(item) {
        var ccenter = { x: item.x, y: item.y };

        var points = DrawFunctions.createArc(0, 2 * Math.PI, ccenter, item.r);
        if (this.projection != null) {
            points.forEach((item, index) => {
                ({ x: points[index][0], y: points[index][1] } = this.transformCoordinates({ x: item[0], y: item[1] }));
            });
        }
        
        var circle = new LineString(points);

        if (item.transforms) {
            DrawFunctions.transformGeom(circle, item.transforms);
        }
        return new Feature(circle);
    }

    draw3DFace(item) {
        var polygonPoints = [];
        var i = 0;
        item.vertices.forEach(vertex => {
            var vertexp = { x: vertex.x, y: vertex.y };
            if (this.projection != null) {
                vertexp = this.transformCoordinates(vertexp);
            }
            if (i == 3)
                polygonPoints.unshift([vertexp.x, vertexp.y]);
            else
                polygonPoints.push([vertexp.x, vertexp.y]);
            i++;
        });
        var polygon = new LineString(polygonPoints);// Note: real openlayers Polygon was not working
        if (item.transforms) {
            DrawFunctions.transformGeom(polygon, item.transforms);
        }
        return new Feature(polygon);
    }

    drawPolygon(item) {
        var rings = []
        item.coordinates.forEach(ring => {
            var vertexpoints = []

            ring.forEach(coordinates => {
                var vertexp = { x: coordinates[0], y: coordinates[1] };
                if (this.projection != null) {
                    vertexp = this.transformCoordinates(vertexp);
                }
                vertexpoints.push([vertexp.x, vertexp.y]);
            });

            rings.push(vertexpoints);
        });

        var polygon = new Polygon(rings);
        return new Feature(polygon);
    }

    drawPolyline(item) {
        var polyLinePoints = [];
        var prevBulge = 0;
        var prevP;
        item.vertices.forEach(vertex => {
            var vertexp = { x: vertex.x, y: vertex.y };
            // if (this.projection != null) {
            //     vertexp = this.transformCoordinates(vertexp);

            //     vertexp = { x: Math.round(vertexp.x * 10000) / 10000, y: Math.round(vertexp.y * 10000) / 10000 };
            // }
            if (prevBulge == 0) {
                polyLinePoints.push([vertexp.x, vertexp.y]);
            } else {
                var points = DrawFunctions.createArcWithBulge(prevP, vertexp, prevBulge);
                // if function returns one point for an arc its probably because the bulge is too small. (code from civilclient)
                if (points.length > 1) {
                    polyLinePoints = polyLinePoints.concat(points);
                } else {
                    // just add the x and y for a straight line
                    polyLinePoints.push([vertexp.x, vertexp.y]);
                }


            }
            if (vertex.bulge != undefined) {
                prevBulge = vertex.bulge;
            } else {
                prevBulge = 0;
            }
            prevP = vertexp;
        });

        
        if (item.closed) {
            var vertexp = { x: item.vertices[0].x, y: item.vertices[0].y };

            if (prevBulge == 0) {
                polyLinePoints.push([vertexp.x, vertexp.y]);
            } else {
                var points = DrawFunctions.createArcWithBulge(prevP, vertexp, prevBulge);
                // if function returns one point for an arc its probably because the bulge is too small. (code from civilclient)
                if (points.length > 1) {
                    polyLinePoints = polyLinePoints.concat(points);
                } else {
                    // just add the x and y for a straight line
                    polyLinePoints.push([vertexp.x, vertexp.y]);
                }
            }
        }

        //transform all coordinates after calculating bulges
        polyLinePoints.forEach((e, i) => {
            if (this.projection != null) {
                var c = this.transformCoordinates({ x: e[0], y: e[1] });
                polyLinePoints[i] = [c.x, c.y];
            }
        });


        var polyLine = new LineString(polyLinePoints);
        if (item.transforms) {
            DrawFunctions.transformGeom(polyLine, item.transforms);
        }
        var feature = new Feature(polyLine);

        var transformedVertices = [];
        item.vertices.forEach(vertex => {
            var vert = { x: vertex.x, y: vertex.y };
            if (this.projection != null) {
                vert = this.transformCoordinates({ x: vert.x, y: vert.y });
            }
            transformedVertices.push([vert.x, vert.y]);
        })

        feature.set('vertices', transformedVertices)
        return feature;
    }

    drawMText(item) {
        var rotation = Math.atan2(item.xAxisY, item.xAxisX);
        var textp = { 'x': item.x, 'y': item.y };
        if (this.projection != null) {
            textp = this.transformCoordinates(textp);
        }
        var text = new Point([textp.x, textp.y]);
        if (item.transforms) {
            DrawFunctions.transformGeom(text, item.transforms);
        }
        var feature = new Feature(text);
        feature.set('text', item.string);
        feature.set('rotation', -rotation);
        feature.set('textheight', item.nominalTextHeight);
        return feature;
    }

    drawHatch(item) {
        var polygonPoints = [];
        item.boundary.loops.forEach(loop => {
            switch (loop.type) { // marc TODO: add more hatch types
                case 0: // Default
                    polygonPoints = this.calcDefaultHatch(loop.entities);
                    break;
                case 1: // External
                    break;
                case 2: // Polyline
                    polygonPoints = this.calcPolylineHatch(loop.entities);
                    break;
                case 4: // Derived

                    break;
                case 8: // Textbox

                    break;
                case 16: // Outermost

                    break;
                default:
                    break;
            }
        })

        var polygon = new Polygon([polygonPoints]);
        var feature = new Feature(polygon);

        feature.set('color', colors[item.colorNumber]) // marc TODO: custom color
        feature.set('itemType', 'HATCH')

        return feature;
    }

    calcPolylineHatch(entities) {
        var polygonPoints = [];
        entities[0].points.forEach(point => {
            var vertexp = { x: point.x, y: point.y };
            if (this.projection != null) {
                vertexp = this.transformCoordinates(vertexp);
            }
            polygonPoints.push([vertexp.x, vertexp.y])
        });
        return polygonPoints;
    }

    calcDefaultHatch(entities) {
        var polygonPoints = [];
        entities.forEach(entity => {
            switch (entity.type) { // marc TODO: add more entity types
                case "LINE":
                    var start = { x: entity.start.x, y: entity.start.y };
                    var end = { x: entity.end.x, y: entity.end.y };

                    if (this.projection != null) {
                        start = this.transformCoordinates(start);
                        end = this.transformCoordinates(end);
                    }
                    polygonPoints.push([start.x, start.y], [end.x, end.y]);
                    break;
                case "ARC":
                case "SPLINE":
                default:
                    throw new Error("Unknown entity type: " + entity.type)
            }
        })

        return polygonPoints;
    }

    transformCoordinates(coordinates) {
        if (this.transformFromProjection) {
            coordinates = DrawFunctions.transformFromProjection(coordinates, this.source);
        }

        if(this.source && this.dest){
            coordinates = proj4.transform(this.source, this.dest, [coordinates.x, coordinates.y]);
        }
        return coordinates;
    }
}
